import { useEffect, useState } from 'react';
import { client } from '../client';

const useWorkHook = () => {
	const [works, setWorks] = useState([]);
	const [filterWork, setFilterWork] = useState([]);
	const [activeFilter, setActiveFilter] = useState('All');
	const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });

	useEffect(() => {
		const query = '*[_type == "works"] | order(_createdAt asc)';

		client.fetch(query).then((data) => {
			setWorks(data);
			setFilterWork(data);
		});
	}, []);

	const programmingLanguageArray = [
		'All',
		'HTML5',
		'CSS',
		'JavaScript(ES6)',
		'React JS',
		'Bootstrap',
		'Tailwind CSS',
		'SCSS',
		'Material-UI',
		'RESTful API',
	];
	const handleWorkFilter = (item) => {
		setActiveFilter(item);
		setAnimateCard([{ y: 100, opacity: 0 }]);

		setTimeout(() => {
			setAnimateCard([{ y: 0, opacity: 1 }]);
			if (item === 'All') {
				setFilterWork(works);
			} else {
				setFilterWork(works.filter((work) => work.tags.includes(item)));
			}
		}, 500);
	};

	return {
		programmingLanguageArray,
		handleWorkFilter,
		filterWork,
		activeFilter,
		animateCard,
	};
};

export default useWorkHook;
